import React from 'react';
import TriggerRuleInfoComponent from 'components/triggers/TriggerRuleInfoComponent';
import TrendActionTypeIcon from 'components/pure/utils/icon/triggers/TrendActionTypeIcon';
import './TrendDetail.styl';
import Link from 'react-router/lib/Link';
import Button from '@material-ui/core/Button';

export default class TrendDetail extends React.Component {
  render() {
    const {rule, location} = this.props;
    if (!rule) return null;

    return (
      <div className="trend-detail-wrapper">
        <div className="trend-detail-header">
          <div className="header">
            <TrendActionTypeIcon />
            <h1>Trend Rule </h1>
          </div>
          <Button
            component={Link}
            variant="contained"
            color="primary"
            className="rule-link-button ev-button"
            to={{
              pathname: '/admin/actions/' + rule.id,
              state: {goBack: location},
            }}>
            View Trend
          </Button>
        </div>
        <div className="trend-description-wrapper">
          <TriggerRuleInfoComponent {...this.props} />
        </div>
      </div>
    );
  }
}
